import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "src/hooks/useRequest";

export const useMostViewdProducts = ( query: Record<string, QueryParamsType>) => {
  const url = `/dashboard/most-viewed-products?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    data: data as any,
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
